import { render, staticRenderFns } from "./EditGenreForm.vue?vue&type=template&id=8541ac20&scoped=true&"
import script from "./EditGenreForm.vue?vue&type=script&lang=js&"
export * from "./EditGenreForm.vue?vue&type=script&lang=js&"
import style0 from "./EditGenreForm.vue?vue&type=style&index=0&id=8541ac20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8541ac20",
  null
  
)

export default component.exports